import React from "react";

export const CategoryMenuBlock: React.FC<any> = async (props) => {
  return null;
};
